import { JWTRole } from "@hackthenorth/north";
import React from "react";
import { Navigate } from "react-router-dom";

import AuthenticationLoadingModal from "src/shared/components/Route/AuthenticationLoadingModal";
import { LEGACY_MENTORSHIP_ENABLED } from "src/shared/constants/featureFlags";
import { Route } from "src/shared/constants/route";
import {
  Permission,
  useEventContext,
  usePermissionsContext,
  useUserContext,
} from "src/shared/contexts";
import { canAccessHackerPostRsvpTools } from "src/shared/utils/hackerPostRsvpAccess";
import { HackerHomeRoutes } from "src/views/hacker/home/routes";
import HackerRsvpHome from "src/views/hacker/rsvp/home";
import { MentorHomeRoute } from "src/views/mentor/routes";
import { SponsorHomeRoutes } from "src/views/sponsor/home/routes";
import { VolunteerHomeRoute } from "src/views/volunteer/routes";

import { HomePage, ScheduleHomeRoutes } from ".";

const AttendeeHome = () => {
  const { hasPermissions } = usePermissionsContext();
  const { roles, isOrganizer } = useUserContext();
  const { hackerPostRsvpTools, isLoading: isEventLoading } = useEventContext();
  const isHackerPostRsvpToolsGateApplicable =
    !isOrganizer && roles.includes(JWTRole.HACKER);
  const canAccessPostRsvpTools = canAccessHackerPostRsvpTools(
    roles,
    isOrganizer,
    hackerPostRsvpTools.isOpen
  );

  if (isHackerPostRsvpToolsGateApplicable && isEventLoading) {
    return <AuthenticationLoadingModal />;
  } else if (!canAccessPostRsvpTools) {
    return <Navigate to={Route.HACKER_RSVP} replace />;
  } else if (hasPermissions([Permission.ORGANIZER])) {
    return <HackerHomeRoutes />;
  } else if (hasPermissions([Permission.VOLUNTEER_EVENT_ACCESS])) {
    return <VolunteerHomeRoute />;
  } else if (hasPermissions([Permission.VOLUNTEER])) {
    return <Navigate to={Route.HACKER_RSVP} replace />;
  } else if (hasPermissions([Permission.HACKER_EVENT_ACCESS])) {
    return <HackerHomeRoutes />;
  } else if (hasPermissions([Permission.HACKER_RSVP])) {
    return <HackerRsvpHome />;
  } else if (hasPermissions([Permission.MENTOR])) {
    return LEGACY_MENTORSHIP_ENABLED ? (
      <MentorHomeRoute />
    ) : (
      <Navigate to={Route.SCHEDULE} replace />
    );
  } else if (hasPermissions([Permission.SPONSOR])) {
    return <SponsorHomeRoutes />;
  } else if (hasPermissions([Permission.WORKSHOP_LEAD])) {
    return <ScheduleHomeRoutes />;
  } else if (hasPermissions([Permission.RSVP])) {
    // Every attendee without a specialized home lands on their RSVP/status.
    return <Navigate to={Route.HACKER_RSVP} replace />;
  } else {
    return <HomePage />;
  }
};

export default AttendeeHome;
